import React, {FC} from 'react';
import {Button, ButtonProps} from '@mui/material';
import {CSVLink} from "react-csv";
import {cleanCsvData} from "../../../util/CsvDataUtil";

/**
 * @deprecated
 */
export interface ExportCSVButtonProps extends ButtonProps {
  /** all formatted data to be exported into the CSV file */
  reportData: any,
  /** the title/header for the exported file */
  reportName: string,
  /** (optional) passed directly to the child CSVLink component (see react-csv docs for more info) */
  csvLinkProps?: any,
  /** the text that displays on the button itself */
  title: string,
}

/**
 * An MUI button component that downloads data as a CSV file.
 * @param reportData The data to be downloaded as CSV.
 * @param reportName The name of the CSV file.
 * @param csvLinkProps Props for CSVLink component. This will override other [CSVLink](https://www.npmjs.com/package/react-csv) related props.
 * @param title The text to display on the button.
 * @param props Properties applied to the [MUI Button](https://v5.mui.com/material-ui/react-button/) component.
 * @constructor
 * @deprecated
 */
const ExportCSVButton: FC<ExportCSVButtonProps> = ({
                                                     reportData,
                                                     reportName,
                                                     csvLinkProps,
                                                     title,
                                                     ...props
                                                   }) => {
  const data = reportData || [];
  const name = reportName || 'Report';

  const CSVLinkProps = {
    filename: name,
    data: cleanCsvData(data) as any,
    separator: ',',
    ...csvLinkProps
  };

  return (<CSVLink {...CSVLinkProps}>
      <Button
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 0.5
        }}
        variant='contained'
        {...props}
      >
        {title}
      </Button>
    </CSVLink>
  );
}

export default ExportCSVButton;
